import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of, Subject,BehaviorSubject } from 'rxjs';
import { map, catchError, retry, delay, scan, tap } from 'rxjs/operators';
// import { environment } from '../../environments/environment';

import { AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ApprovalFlow, ApprovalFlowRequest } from '../pages/master/models/approval.model';
import { Client } from '../pages/master/models/client.model';
import { environment } from 'src/environments/environment';




@Injectable({ providedIn: 'root' })
export class SharedService {
 // private baseUrl = environment.apiUrl;
  branchChanged: Subject<number> = new Subject<number>();


  private yearChangeSource = new BehaviorSubject<any>(localStorage.getItem("yearKey"));
  public yearChanged$ = this.yearChangeSource.asObservable();

  constructor(private _http: HttpClient) {
    
   }


   public getDashboardKpis(branchKey?: number | null): Observable<any> {
    let url = `${environment.apiBase}/api/dashboard/purchase/kpis`; // Make sure this matches your Java controller!
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchId=${branchKey}`;
    }
    return this._http.get<any>(url);
  }
   

  //  // Existing method

getClientsWithApprovedWorkOrders(): Observable<Client[]> {
  return this._http.get<Client[]>(`${environment.apiBase}/workorder/approved-clients`);
}

  // // NEW METHOD: Fetch only clients with approved Work Orders
  // getClientsWithApprovedWorkOrders(): Observable<Client[]> {
  //   return this.http.get<Client[]>(`${this.apiUrl}/work-orders/approved-clients`);
  // }

 // --- Material Return to Godown API Calls ---
  
  // getAllMaterialReturnToGodownByPageCount(payload: any) {
  //   return of({ totalData: 0, data: [] }); 
  // }
  getAllMaterialReturnToGodownByPageCount(payload: any) {

  return this._http.get<any>(
    environment.apiBase + '/material-return-godown',
    {
      params: {
        page: payload.page,
        limit: 15,
        searchText: payload.searchText || '',
        siteKey: payload.siteId || 0,
        godownKey: payload.godownId || 0
      }
    }
  );

}

  getSites(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/sitescontroller/getall?isForTrans=true');
  }

  getGodowns(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/warehouse/all');
  }



//   getProductsBySite(siteId: any): Observable<any> {
//   return this._http.get<any>(`${environment.apiBase}stock/available/products/site/${siteId}`); 
// }
  
getProductsBySite(siteId: any): Observable<any[]> {
    // 1. Safely handle the base URL just in case it already has a trailing slash or is missing one
    const baseUrl = environment.apiBase.endsWith('/') 
      ? environment.apiBase.slice(0, -1) 
      : environment.apiBase;

    // 2. Construct the URL perfectly
    const url = `${baseUrl}/stock/available/products/site/${siteId}`;
    
    // 3. Log it so you can confirm it looks like http://localhost:8080/stock/...
    console.log("Safe API URL is: ", url); 

    // 4. Make the call
    return this._http.get<any[]>(url); 
  }

// getAvailableStock(siteId: any, productId: any, makeId: any): Observable<any> {
//   return this._http.get<any>(`${environment.apiBase}/stock/available/products/site/${siteId}`, {
//     params: { 
//       productId: productId, 
//       makeId: makeId 
//     }
//   });
// }


getAvailableStock(siteId: any, productId: any, makeId: any): Observable<any> {
    // Safely format base URL
    const baseUrl = environment.apiBase.endsWith('/') 
      ? environment.apiBase.slice(0, -1) 
      : environment.apiBase;

    // Call the correct endpoint path without /products/
    return this._http.get<any>(`${baseUrl}/stock/available/site/${siteId}`, {
      params: { 
        productId: productId, 
        makeId: makeId 
      }
    });
  }


  getMakesByProduct(productId: any, siteId: any): Observable<any> {
    let params = new HttpParams().set('productId', productId);
    if (siteId) {
      params = params.set('siteId', siteId);
    }
    return this._http.get<any>(`${environment.apiBase}/stock/makes`, { params });
  }

  
  // ==========================================
  // --- Liability Master API Calls ---
  // ==========================================

  getAllLiabilities(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/api/liability/all`);
  }

  createLiability(payload: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/api/liability/create`, payload);
  }

  updateLiability(id: any, payload: any): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/api/liability/update/${id}`, payload);
  }

  updateLiabilityStatus(id: any): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/api/liability/updatestatus/${id}`, {});
  }

  checkLiabilityNameDuplicate(liabilityName: string, id?: any): Observable<boolean> {
    let url = `${environment.apiBase}/api/liability/check-name?liabilityName=${encodeURIComponent(liabilityName)}`;
    if (id) {
      url += `&id=${id}`;
    }
    return this._http.get<boolean>(url);
  }


// -------------------------------------------------------------

  createGodownReturn(payload: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/material-return-godown`, payload);
  }

  updateGodownReturn(id: string, payload: any): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/material-return-godown/${id}`, payload);
  }

  getGodownReturnById(id: string): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/material-return-godown/${id}`);
  }
  
  // ---------------------------------------------------

  emitBranchChange(branchKey: number): void {
    this.branchChanged.next(branchKey);
  }

  getAllDist(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/signup/district/all');
  }

  getAllStates(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/signup/state/all');
  }

  getDistrict(stateId): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/signup/district/all/' + stateId);
  }

  getTaluka(distId): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/signup/taluka/all?district=${distId}`)
  }

  createCompany(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/company/create', payload)
  }

  updateCompany(payload, companyKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/company/update/' + companyKey, payload)
  }

  approvalCompany(payload): Observable<any> {
    return this._http.patch<any>(environment.apiBase + '/company/approvalflow', payload)
  }

  addApproverCompany(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/approvalflow/create', payload)
  }

  updateApproverCompany(payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/approvalflow/update', payload)
  }

  getApprovalCompany(moduleName) {
    return this._http.get<any>(environment.apiBase + `/approvalflow/get/${moduleName}`)
  }

  getTdsByBusinessType(businessType: string): Observable<any> {
    return this._http.get<any>(
        `${environment.apiBase}/tds/by-business-type?businessType=${businessType}`
    );
}

  getCompanyDetailsById(id: any) {
    return this._http.get<any>(`${environment.apiBase}/company/get?id=` + id);
  }

  getBranches() {
    return this._http.get<any[]>(`${environment.apiBase}/branch/all`);
  }

  getBranchesByUser() {
    return this._http.get<any[]>(`${environment.apiBase}/branch/user`);
  }

  createBranch(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/branch/create', payload)
  }

  updateBranch(payload, branchKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/branch/update/' + branchKey, payload)
  }

  syncuserTobranch(branchKey:any): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/branch/sync/' + branchKey,{})
  }

  getWarehouses() {
    return this._http.get<any[]>(`${environment.apiBase}/warehouse/all`);
  }

  getActiveWarehouses() {
    return this._http.get<any[]>(`${environment.apiBase}/warehouse/all?active=true`);
  }

  createWarehouse(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/warehouse/create', payload)
  }

  updateWarehouse(payload, warehouseKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/warehouse/update/' + warehouseKey, payload)
  }
  fetchWarehouseByProductKey(productKey) {
    return this._http.get<any[]>(`${environment.apiBase}/stock/balancestock/` + productKey);
  }

  getStockByProduct(productKey: any, makeKey: any, warehouseKey: any) {
    return this._http.get<any[]>(`${environment.apiBase}/stock/getStockByProduct`, {
      params: { productKey, makeKey, warehouseKey }
    });
  }

  deleteClient(id): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/client/updatestatus/' + id, {})
  }

  deleteClientById(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/client/delete/' + id);
  }

  getClients() {
    return this._http.get<any[]>(`${environment.apiBase}/client/all`);
  }

  getClientsByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/client/all/bypagination`,{ params });
  }

  getAllActiveClients() {
    return this._http.get<any[]>(`${environment.apiBase}/client/all?isForTrans=true`);
  }

   getAllActiveClientsSitePlanning() {
    return this._http.get<any[]>(`${environment.apiBase}/client/all-siteplanning?isForTrans=true`);
  }

  createClient(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/client/create', payload)
  }

  updateClient(payload, clientKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/client/update/' + clientKey, payload)
  }

  getSuppliersByPagination(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/supplier/all/bypagination`,{ params });
  }

  getSuppliers() {
    return this._http.get<any[]>(`${environment.apiBase}/supplier/all?isTransaction=true`);
  }

  getActiveSupplierCount() {
    return this._http.get<any>(`${environment.apiBase}/supplier/active/count`);
  }

  getSuppliersBill() {
    return this._http.get<any[]>(`${environment.apiBase}/supplier/all?isTransaction=true&forSupBill=true`);
  }

  getSuppliersForPayment() {
    return this._http.get<any[]>(`${environment.apiBase}/supplier/all?isTransaction=true&forSupPayment=true`);
  }

  getProductsForMapping(supplierKey: any, searchText: string, categoryKey: any) {
    let params = new HttpParams().set('supplierKey', supplierKey);
    if (searchText) { params = params.set('searchText', searchText); }
    if (categoryKey) { params = params.set('categoryKey', categoryKey); }
    return this._http.get<any[]>(`${environment.apiBase}/supplier/products-for-mapping`, { params });
  }

  saveProductMapping(payload: { supplierKey: any, productKeys: any[] }): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/supplier/map-products`, payload);
  }

  getConcernPersonsByClientId(clientKey: any): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/client/concern-persons/` + clientKey);
  }

  getInvoice(supplierKey:any) {
     return this._http.get<any[]>(`${environment.apiBase}/purchaseinvoice/status/${supplierKey}`);
  }

  getProduct(InvoiceKey:any) {
     return this._http.get<any[]>(`${environment.apiBase}/purchaseinvoice/get?id=${InvoiceKey}`);
  }

  getSuppliersByQR(quotationKey:any) {
    return this._http.get<any[]>(`${environment.apiBase}/supplier?forQuoEntry=true&quotationKey=${quotationKey}`);
  }

  getPendingGrnSupplier() {
    return this._http.get<any[]>(`${environment.apiBase}/supplier/getPendingGrnSupplier`);
  }

  createSupplier(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/supplier/create', payload)
  }

  updateSupplier(payload, supplierKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/supplier/update/' + supplierKey, payload)
  }

  deleteSupplier(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/supplier/delete/' + id);
  }

  // importSupplier(file: File): Observable<any> {
  //   const formData = new FormData();
  //   if (file) {
  //     formData.append('file', file, file.name);
  //   }
  //   return this._http.post(environment.apiBase + '/supplier/upload', formData)
  // }

    importSupplier(file: File): Observable<any> {
    const formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
    }

     return this._http.post(environment.apiBase + '/supplier/upload', formData, {
      responseType: 'blob',
      observe: 'response'  // ✅ Get full response including headers
    });
  }


  // getallRoles
  getAllActiveRoles(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/roles/all?isTransaction=true');
  }

  // change pswword 
  changeNewPassword(payload, id): Observable<any> {
    return this._http.put<any[]>(environment.apiBase + '/api/user/updatepass/' + id, payload);
  }

  //Permission
  createPermission(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/permission/create', payload)
  }

  getPermissionyDetailsById(role: any) {
    return this._http.get<any>(`${environment.apiBase}/permission/get?role=` + role);
  }

  updatePermission(payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/permission/update', payload)
  }


  //Role Module Permission
  getModulePermssionByRoles(id:any): Observable<any[]> {
    return this._http.get<any>(`${environment.apiBase}/role-modules?export=true&roleId=` + id);
  }

  getAllModules(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/modules?export=true');
  }
  
    //Permission
    createModulePermission(id,payload): Observable<any> {
      return this._http.post<any>(environment.apiBase + `/role-modules?roleId=${id}`, payload)
    }
  
    getModuleDetailsById(role: any) {
      return this._http.get<any>(`${environment.apiBase}/role-modules/` + role);
    }
  
    updateModulePermission(payload): Observable<any> {
      return this._http.put<any>(environment.apiBase + '/role-modules/update', payload)
    }
  

    //Upload Logo
    uploadBranchimage(id,formData): Observable<any> {
      return this._http.post<any>(environment.apiBase + `/upload/image/${id}/BRANCH`, formData)
    }
  

    //send Email
     sendEmail(formData: any): Observable<any> {
           return this._http.post<any>(environment.apiBase + `/role-modules/update`, formData)
    }
    /////////////////////////material return//////////////////

    createMaterialReturn(payload): Observable<any> {
      return this._http.post<any>(`${environment.apiBase}/supplier-material-return/create`, payload)
    }

    
  getAllMaterialReturnByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/supplier-material-return/all`,{ params });
  }
      getAllMaterialReturn(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/supplier-material-return/all`);
  }
      getMaterialReturnDetailsBYid(id): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/supplier-material-return/get/${id}`);
  }

   updateMaterialReturn(id,payload): Observable<any> {
      return this._http.put<any>(`${environment.apiBase}/supplier-material-return/update/${id}`, payload)
    }

    ApproveMaterialReturnToSupplier(id,payload): Observable<any> {
      return this._http.put<any>(`${environment.apiBase}/supplier-material-return/approve/${id}`, payload)
    }

        RejectMaterialReturnToSupplier(id,payload): Observable<any> {
      return this._http.put<any>(`${environment.apiBase}/supplier-material-return/reject/${id}`, payload)
    }

  ////////////////////////////////////advancereceiptentry//////////////////////////////////////////////

  getSiteData(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/sitescontroller/getall?isForTrans=true');
  }

  getBankData(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/bank/all');
  }


  getAdvanceReceiptAll(): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/client-adv-payment`)
  }


  getAdvanceReceiptByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/client-adv-payment`, { params })
  }

  createAdvanceReceipt(payload): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/client-adv-payment`, payload)
  }
  getAdvanceReceiptById(id): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/client-adv-payment/${id}`)
  }

  updateAdvanceReceipt(id, payload): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/client-adv-payment/${id}`, payload)
  }

  AdvanceReceiptApprove(id, payload): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/client-adv-payment/approve/${id}`, payload)
  }

  AdvanceReceiptReject(id, payload): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/client-adv-payment/reject/${id}`, payload)
  }

  getclientAdvPayment(siteKey): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/client-adv-payment/total-amount/${siteKey}`);
  }

     /////////////////////////////contractor-payment-request///////////////////////////////////

     getContractordata(): Observable<any> {
      return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/status?contractor=true&forBillEntry=true&forConPayment=true&forTrans=true`)
  }

  getReturndataofsubcontractor():Observable<any>{
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/status?contractor=false&forBillEntry=true&forConPayment=true&forTrans=true&forConPayment=true`)
  }
  getbillentry(id):Observable<any>{
    return this._http.get<any>(`${environment.apiBase}/contractor-bill-entry?subConWoKey=${id}&forBillPayment=true`)
  }

    getContractorPaymentRequestById(id): Observable<any> {
      return this._http.get<any>(`${environment.apiBase}/contractor-receipt-payment/${id}`)
  }

     ContractorPaymentRequestApprove(id,payload): Observable<any> {
      return this._http.put<any>(`${environment.apiBase}/contractor-receipt-payment/approve/${id}`, payload)
    }

     ContractorPaymentRequestReject(id,payload): Observable<any> {
      return this._http.put<any>(`${environment.apiBase}/contractor-receipt-payment/reject/${id}`, payload)
    }

       updateContractorPaymentRequest(id,payload): Observable<any> {
      return this._http.put<any>(`${environment.apiBase}/contractor-receipt-payment/${id}`, payload)
    }

      
    createContractorPaymentRequest(payload): Observable<any> {
      return this._http.post<any>(`${environment.apiBase}/contractor-receipt-payment`, payload)
    }


  getContractorPaymentRequest(id): Observable<any> {
      return this._http.get<any>(`${environment.apiBase}/contractor-receipt-payment`)
  }

   getContractorPaymentRequestPaginated(params = {}): Observable<any> {
      return this._http.get<any>(`${environment.apiBase}/contractor-receipt-payment`,{ params })
  }

  geProductTypet(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/product-type/all');
  }
//--------finacial year
public getAllYear() {
  return this._http.get(`${environment.apiBase}/year/getAllYear`); // Adjust url pattern if your shared service uses a specific base URL variable
}
// public emitYearChange(yearKey: number) {
//     this.yearChangeSource.next(yearKey);
//   }
public emitYearChange(yearKey: number) {
  console.log('Saving Year Key:', yearKey);

  localStorage.setItem('yearKey', yearKey.toString());

  this.yearChangeSource.next(yearKey);
}

  //newly added method for email id exist validation
  emailExistsValidator(): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

    if (!control.value) {
      return of(null);
    }

    if (control.invalid) {
      return of(null);
    }

    return this._http.get<boolean>(
      `${environment.apiBase}/client/check-email?email=${control.value}`
    ).pipe(
      debounceTime(500),
      map(exists => {
        return exists ? { emailExists: true } : null;
      }),
      catchError(() => of(null))
    );
  };
}


//newly added method for email id exist validation
 concernemailExistsValidator(): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

    if (!control.value) {
      return of(null);
    }

    if (control.invalid) {
      return of(null);
    }

    return this._http.get<boolean>(
      `${environment.apiBase}/client/check-email?concernPersonEmailId=${control.value}`
    ).pipe(
      debounceTime(500),
      map(exists => {
        return exists ? { emailExists: true } : null;
      }),
      catchError(() => of(null))
    );
  };
}



//number exists
//   numberExistsValidator(): AsyncValidatorFn {
//   return (control: AbstractControl): Observable<ValidationErrors | null> => {

//     if (!control.value) {
//       return of(null);
//     }

//     if (control.invalid) {
//       return of(null);
//     }

//     return this._http.get<boolean>(
//       `${environment.apiBase}/client/check-number?contactNumber=${control.value}`
//     ).pipe(
//       debounceTime(500),
//       map(exists => {
//         return exists ? { mobileExists: true } : null;
//       }),
//       catchError(() => of(null))
//     );
//   };
// }

numberExistsValidator(): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

    if (!control.value) {
      return of(null);
    }

    if (control.invalid) {
      return of(null);
    }

    // ── get clientKey from parent form ──
    const clientKey = control.parent?.get('clientKey')?.value;

    // ── build url based on create or edit mode ──
    const url = clientKey
      ? `${environment.apiBase}/client/check-number?contactNumber=${control.value}&clientKey=${clientKey}`
      : `${environment.apiBase}/client/check-number?contactNumber=${control.value}`;

    return this._http.get<boolean>(url).pipe(
      debounceTime(500),
      map(exists => {
        return exists ? { mobileExists: true } : null;
      }),
      catchError(() => of(null))
    );
  };
}
addApproverCompanyExpense(data: ApprovalFlowRequest): Observable<ApprovalFlow[]> {
  return this._http.post<ApprovalFlow[]>(`${environment.apiBase}/approvalflow/expense/create`, data);
}

updateApproverCompanyExpense(data: ApprovalFlowRequest): Observable<ApprovalFlow[]> {
  return this._http.put<ApprovalFlow[]>(`${environment.apiBase}/approvalflow/expense/update`, data);
}

getExpenseApprovalByUserId(userId: number) {
  return this._http.get<any>(`${environment.apiBase}/approvalflow/expense/get/${userId}`);
}

getUsersByExpenseFlag(): Observable<any[]> {
  return this._http.get<any[]>(`${environment.apiBase}/user/getallusers`);
}



checkApproverPendingExpense(approverId: number, userId: number): Observable<any> {
  return this._http.get<any>(
    `${environment.apiBase}/approvalflow/expense/check-pending/${approverId}`,
    {
      params: {
        userId: userId
      }
    }
  );
}

} 